<div [class.progress-bar-initial-section]="stepNumber === 0" [class.progress-bar-section]="stepNumber !== 0"
  class="progress-bar-wrapper columns is-vcentered is-centered is-mobile">
  <div *ngIf="stepNumber !== 0" class="progress-bar-content column is-full">
    <div [ngClass]="{'progress-text-box-stepOne' : stepNumber === 1, 'progress-text-box-stepTwo' : stepNumber === 2, 'progress-text-box-stepThree' : stepNumber === 3, 'progress-text-box-stepFour' : stepNumber === 4}">
      <p class="progress-bar-text">Progress</p>
    </div>
    <div class="bar-container">
      <div class="grey-bar"></div>
      <div class="colored-progress"
        [ngClass]="{ 'is-first' : stepNumber === 1, 'is-second' : stepNumber === 2, 'is-third' : stepNumber === 3, 'is-fourth' : stepNumber === 4}">
      </div>

    </div>
  </div>
</div>